import apiClient, { rapidApiClient } from "./config";
import { JOBS_ENDPOINTS } from "./endpoints";

const jobsService = {
  searchJobs: (payload) => {
    return apiClient.get(JOBS_ENDPOINTS.SEARCH_JOBS, {
      params: payload,
    });
  },
  jobsFilter: () => {
    return apiClient.get(JOBS_ENDPOINTS.JOBS_FILTER);
  },

  // searchJobs: (payload) => {
  //     return rapidApiClient.get(JOBS_ENDPOINTS.SEARCH_JOBS, {
  //         params: payload
  //     })
  // },
  getEstimatedSalary: (payload) => {
    return rapidApiClient.get(JOBS_ENDPOINTS.ESTIMATED_SALARY, {
      params: payload,
    });
  },
  getJobsByStateAndCity: (payload) => {
    return apiClient.get(
      `${JOBS_ENDPOINTS.JOBS_BY_CITY_AND_STATE}/${payload.city}/${payload.state}`,
    );
  },

  getJobDetail: (id) => {
    return apiClient.get(`${JOBS_ENDPOINTS.JOB_DETAIL}/${id}`);
  },
  getPublicJobDetail: (id) => {
    return apiClient.get(`${JOBS_ENDPOINTS.PUBLIC_JOB_DETAIL}/${id}/public`);
  },
  getSimilarJobs: ({ id, page = 1, limit = 6 }) => {
    return apiClient.get(`${JOBS_ENDPOINTS.SIMILAR_JOBS}/${id}/similar`, {
      params: { page, limit },
    });
  },
  applyJob: ({ job_id, data }) => {
    return apiClient.post(`${JOBS_ENDPOINTS.APPLY_JOB}/${job_id}/apply`, data, {
      headers: {
        "Content-Type": "multipart/form-data", // ✅ FIX
      },
    });
  },
  // applyJob: ({ job_id, data }) => {
  //   return apiClient.post(`${JOBS_ENDPOINTS.APPLY_JOB}/${job_id}/apply`, data);
  // },
  jobTracking: (data) => {
    return apiClient.post(JOBS_ENDPOINTS.JOB_TRACKING, data);
  },
  trackApplyClick: (jobId) => {
    return apiClient.post(`${JOBS_ENDPOINTS.APPLY_CLICK}/${jobId}/apply-click`);
  },
  toggleBookmark: (data) => {
    return apiClient.post(JOBS_ENDPOINTS.TOGGLE_BOOKMARK, data);
  },
  checkMultipleBookmarks: (data) => {
    return apiClient.post(JOBS_ENDPOINTS.CHECK_MULTIPLE_BOOKMARKS, data);
  },
  checkBookmark: (jobId) => {
    return apiClient.get(`${JOBS_ENDPOINTS.CHECK_BOOKMARK}/${jobId}`);
  },
  getBookmarkJob: (params) => {
    return apiClient.get(JOBS_ENDPOINTS.GET_BOOKMARK_JOB, {
      params: params,
    });
  },
  nurseProfile: (params = {}) => {
    return apiClient.get(JOBS_ENDPOINTS.NURSE_PROFILE, {
      params: params,
    });
  },
  jobStatus: (params) => {
    return apiClient.get(JOBS_ENDPOINTS.JOB_STATUS, {
      params: params,
    });
  },
  seheduleInterview: (applicationId, data) => {
    return apiClient.put(
      `${JOBS_ENDPOINTS.SCHEDULE_INTERVIEW}/${applicationId}/interview-response`,
      data,
    );
  },
  jobsDocument: (applicationId, data) => {
    return apiClient.post(
      `${JOBS_ENDPOINTS.JOBS_DOCUMENT}/${applicationId}/documents/upload`,
      data,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      },
    );
  },
  appliedJob: (id) => {
    return apiClient.get(
      `${JOBS_ENDPOINTS.APPLYED_JOB}/${id}/application-status`,
    );
  },
  personalizedJobs: () => {
    return apiClient.get(JOBS_ENDPOINTS.PERSONALIZED_JOBS);
  },
};

export default jobsService;
